import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7312ba7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "modal"
}
const _hoisted_4 = { class: "contenedor" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Información", -1))
const _hoisted_6 = { class: "contenido" }
const _hoisted_7 = { class: "contenido" }
const _hoisted_8 = {
  target: "_blank",
  href: "https://amadita.com/"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "general" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "side" }
const _hoisted_13 = { class: "row2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"0px"} }, "Iniciar Sesión", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"margin-top":"0px"} }, " Por favor, ingrese sus credenciales ", -1))
const _hoisted_18 = { class: "error" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "grid" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "username"
}, "Nombre de usuario", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label col-form-label-sm mt-4",
  for: "password"
}, "Contraseña", -1))
const _hoisted_23 = ["type"]
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-check" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Mostrar Contraseña ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "¿No tienes cuenta?", -1))
const _hoisted_28 = { class: "main" }
const _hoisted_29 = {
  target: "_blank",
  href: "https://amadita.com/"
}
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "img",
                src: 
          'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
        
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    ($data.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                for: "btn-modal",
                class: "close"
              }, "Cerrar"),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "flyer2",
                    src: 
                'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/informacion.png'
              
                  }, null, 8, _hoisted_9)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("form", null, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      class: "localIMG",
                      src: 
                    'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
                  
                    }, null, 8, _hoisted_14)
                  ]),
                  _hoisted_15,
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("h6", _hoisted_18, _toDisplayString($data.error), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            type: "text",
                            id: "username",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.usuario.username) = $event))
                          }, null, 512), [
                            [_vModelText, $data.usuario.username]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_22,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            type: $data.passwordFieldType,
                            id: "password",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.usuario.password) = $event))
                          }, null, 8, _hoisted_23), [
                            [_vModelDynamic, $data.usuario.password]
                          ])
                        ]),
                        _createElementVNode("fieldset", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (this.togglePasswordFieldType())),
                              class: "form-check-input",
                              type: "checkbox",
                              value: "",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.flexCheckDefault) = $event)),
                              id: "flexCheckDefault"
                            }, null, 544), [
                              [_vModelCheckbox, $data.flexCheckDefault]
                            ]),
                            _hoisted_26
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($options.login()), ["prevent"]))
                    }, " Iniciar Sesión "),
                    _hoisted_27,
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (this.$router.push(`/signup`)), ["prevent"]))
                    }, " Regístrate ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("a", _hoisted_29, [
                _createElementVNode("img", {
                  class: "flyer",
                  src: 
                'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/informacion.png'
              
                }, null, 8, _hoisted_30)
              ])
            ])
          ])
        ], 512), [
          [_vShow, !$data.cargando]
        ])
      ]),
      _: 1
    })
  ], 64))
}